import React, { useState } from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { User, Mail, Phone, MapPin, Search, Filter, Microscope, BookOpen, Award } from 'lucide-react';

const ResearchAssistants = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('all');

  const researchAssistants = [
    {
      id: 1,
      name: 'Arş. Gör. Dr. Deniz Özkan',
      department: 'Matematik',
      email: 'deniz.ozkan@hacettepe.edu.tr',
      phone: '+90 312 297 1010',
      office: 'Matematik Bölümü, Kat 2, Oda 201',
      researchArea: 'Sayısal Analiz, Optimizasyon',
      degree: 'Doktora',
      image: '/api/placeholder/150/200'
    },
    {
      id: 2,
      name: 'Arş. Gör. Cem Yılmaz',
      department: 'Fizik',
      email: 'cem.yilmaz@hacettepe.edu.tr',
      phone: '+90 312 297 2020',
      office: 'Fizik Bölümü, Kat 3, Oda 315',
      researchArea: 'Parçacık Fiziği, Astrofizik',
      degree: 'Yüksek Lisans',
      image: '/api/placeholder/150/200'
    },
    {
      id: 3,
      name: 'Arş. Gör. Dr. Burcu Kaya',
      department: 'Kimya',
      email: 'burcu.kaya@hacettepe.edu.tr',
      phone: '+90 312 297 3030',
      office: 'Kimya Bölümü, Kat 2, Oda 225',
      researchArea: 'Nanokimya, Malzeme Bilimi',
      degree: 'Doktora',
      image: '/api/placeholder/150/200'
    },
    {
      id: 4,
      name: 'Arş. Gör. Onur Demir',
      department: 'Biyoloji',
      email: 'onur.demir@hacettepe.edu.tr',
      phone: '+90 312 297 4040',
      office: 'Biyoloji Bölümü, Kat 3, Oda 302',
      researchArea: 'Hücre Biyolojisi, Stem Hücre',
      degree: 'Yüksek Lisans',
      image: '/api/placeholder/150/200'
    },
    {
      id: 5,
      name: 'Arş. Gör. Dr. Gizem Arslan',
      department: 'İstatistik',
      email: 'gizem.arslan@hacettepe.edu.tr',
      phone: '+90 312 297 5050',
      office: 'İstatistik Bölümü, Kat 1, Oda 120',
      researchArea: 'Makine Öğrenmesi, Büyük Veri',
      degree: 'Doktora',
      image: '/api/placeholder/150/200'
    },
    {
      id: 6,
      name: 'Arş. Gör. Tolga Şahin',
      department: 'Bilgisayar Mühendisliği',
      email: 'tolga.sahin@hacettepe.edu.tr',
      phone: '+90 312 297 6060',
      office: 'Bilgisayar Mühendisliği Bölümü, Kat 2, Oda 250',
      researchArea: 'Yapay Zeka, Doğal Dil İşleme',
      degree: 'Yüksek Lisans',
      image: '/api/placeholder/150/200'
    },
    {
      id: 7,
      name: 'Arş. Gör. Elif Tuncer',
      department: 'Matematik',
      email: 'elif.tuncer@hacettepe.edu.tr',
      phone: '+90 312 297 7070',
      office: 'Matematik Bölümü, Kat 1, Oda 125',
      researchArea: 'Topoloji, Geometri',
      degree: 'Yüksek Lisans',
      image: '/api/placeholder/150/200'
    },
    {
      id: 8,
      name: 'Arş. Gör. Dr. Mert Öztürk',
      department: 'Fizik',
      email: 'mert.ozturk@hacettepe.edu.tr',
      phone: '+90 312 297 8080',
      office: 'Fizik Bölümü, Kat 1, Oda 135',
      researchArea: 'Optik, Lazer Fiziği',
      degree: 'Doktora',
      image: '/api/placeholder/150/200'
    }
  ];

  const departments = ['Matematik', 'Fizik', 'Kimya', 'Biyoloji', 'İstatistik', 'Bilgisayar Mühendisliği'];

  const filteredAssistants = researchAssistants.filter(assistant => {
    const matchesSearch = assistant.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         assistant.researchArea.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesDepartment = selectedDepartment === 'all' || assistant.department === selectedDepartment;
    return matchesSearch && matchesDepartment;
  });

  return (
    <PageTemplate 
      title="Araştırma Görevlileri"
      breadcrumb={[
        { label: 'Anasayfa', url: '/' },
        { label: 'Fakülte Personeli', url: '/fakulte-personeli' },
        { label: 'Araştırma Görevlileri' }
      ]}
    >
      <div className="max-w-7xl mx-auto">
        {/* Başlık */}
        <div className="bg-gradient-to-br from-teal-50 to-cyan-100 rounded-xl p-8 mb-8">
          <div className="flex items-center mb-4">
            <Microscope className="w-8 h-8 text-teal-600 mr-3" />
            <h2 className="text-2xl font-bold text-gray-800">Araştırma Görevlileri</h2>
          </div>
          <p className="text-gray-700">
            Fakültemizde görev yapan araştırma görevlilerinin iletişim bilgilerine ve araştırma alanlarına buradan ulaşabilirsiniz.
          </p>
        </div>

        {/* Filtreler */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Arama */}
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Ad veya araştırma alanı ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
              />
            </div>

            {/* Bölüm Filtresi */}
            <div className="relative">
              <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <select
                value={selectedDepartment}
                onChange={(e) => setSelectedDepartment(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all appearance-none bg-white"
              >
                <option value="all">Tüm Bölümler</option>
                {departments.map(dept => (
                  <option key={dept} value={dept}>{dept}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Araştırma Görevlileri Kartları */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredAssistants.map((assistant) => (
            <div 
              key={assistant.id}
              className="bg-white rounded-xl shadow-sm border border-gray-200 hover:shadow-lg transition-all duration-300 overflow-hidden"
            >
              <div className="p-6">
                <div className="flex items-center space-x-4 mb-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-teal-100 to-cyan-200 rounded-full flex items-center justify-center">
                    <User className="w-8 h-8 text-teal-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800">{assistant.name}</h3>
                    <p className="text-teal-600 font-medium">Araştırma Görevlisi</p>
                  </div>
                </div>

                <div className="space-y-3">
                  <div className="flex items-center text-gray-600">
                    <BookOpen className="w-4 h-4 mr-2" />
                    <span className="text-sm">{assistant.department}</span>
                  </div>
                  
                  <div className="flex items-center text-gray-600">
                    <Award className="w-4 h-4 mr-2" />
                    <span className="text-sm">{assistant.degree}</span>
                  </div>
                  
                  <div className="flex items-start text-gray-600">
                    <Microscope className="w-4 h-4 mr-2 mt-0.5" />
                    <span className="text-sm">{assistant.researchArea}</span>
                  </div>

                  <div className="flex items-center text-gray-600">
                    <Mail className="w-4 h-4 mr-2" />
                    <a 
                      href={`mailto:${assistant.email}`}
                      className="text-sm hover:text-teal-600 transition-colors"
                    >
                      {assistant.email}
                    </a>
                  </div>

                  <div className="flex items-center text-gray-600">
                    <Phone className="w-4 h-4 mr-2" />
                    <span className="text-sm">{assistant.phone}</span>
                  </div>

                  <div className="flex items-start text-gray-600">
                    <MapPin className="w-4 h-4 mr-2 mt-0.5" />
                    <span className="text-sm">{assistant.office}</span>
                  </div>
                </div>

                <div className="mt-4 pt-4 border-t border-gray-100">
                  <button className="w-full bg-teal-600 hover:bg-teal-700 text-white py-2 px-4 rounded-lg transition-colors text-sm font-medium">
                    Araştırma Detayları
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Sonuç bulunamadı */}
        {filteredAssistants.length === 0 && (
          <div className="text-center py-12">
            <User className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-600 mb-2">Araştırma görevlisi bulunamadı</h3>
            <p className="text-gray-500">
              Arama kriterlerinize uygun araştırma görevlisi bulunmamaktadır. Lütfen farklı terimler deneyin.
            </p>
          </div>
        )}
      </div>
    </PageTemplate>
  );
};

export default ResearchAssistants; 